import { RfqForm } from '../components/RfqForm'
import { useT } from '../i18n'
import { usePageMeta } from '../lib/meta'

export function RfqPage() {
  const t = useT()
  usePageMeta(t('meta.book.title'), t('meta.book.desc'), '/book')
  return (
    <div className="mx-auto max-w-2xl px-5 pt-14 pb-10">
      <h1 className="font-display text-4xl font-light text-center">{t('rfq.title')}</h1>
      <p className="mt-3 text-center text-muted leading-relaxed">{t('rfq.sub')}</p>
      <div className="mt-8 rounded-lg border border-border-strong bg-surface-0 p-6">
        <RfqForm />
      </div>
    </div>
  )
}
